import { isNil } from "lodash";
import { calculateTotalCost } from "src/allocation/util/budgetAndCost";
import { roundFte } from "src/util/roundingStrategy";
import { PENDING } from "../../../../../saveStatus";
import { PLANNER_REQUESTED } from "../../../../../columnTypes";
import {
  newNotification,
  newPlannerRequestorCellNotification,
} from "../../../newNotification";

import newCell from "../../newCell";
import getFte from "./getFte";

const getPrepopulatedValueFromForecast = (
  isRequestor,
  forecastedAt,
  requestSavedAt,
  forecast,
  value
) => {
  // we have a forecasted value, without saving anything yet, and it's different from original
  if (isRequestor && forecastedAt && !requestSavedAt && forecast !== value) {
    return [forecast, PENDING];
  }

  return [null, null];
};

export default ({
  lineItem,
  macroAllocation,
  allocationProject,
  isRequestor,
  isEditable,
  useDeltaForBudget,
  useRealtimeChangeOnly,
}) => {
  const {
    id,
    targetGroupId,
    sourceGroupId,
    allocationProjectId,
    requested,
    requestSavedAt,
    requestSubmitted,
    allocatedMemberFte, // reference fte
    forecast,
    forecastedAt,
    note, // skills
    realtimeCurrentMemberFte: realtimeFte,
  } = macroAllocation;
  const { workingDays, disablePlannerRequirementInput } = allocationProject;
  const { dailyRate, isSkillsMandatory, grouping } = lineItem;
  const { isMovedOut } = grouping;

  let value;
  let defaultedValue;
  let realtimeCurrentMemberFte;
  let delta;
  let notification;

  if (grouping.isMovedOut) {
    value = 0;
    defaultedValue = getFte(allocatedMemberFte) || 0;
    realtimeCurrentMemberFte = getFte(
      isNil(realtimeFte) ? defaultedValue : realtimeFte
    );
    delta = -defaultedValue;
    notification = newNotification({
      status: null,
      message: null,
      groupMessage: null,
      columnMessage: null,
    });
  } else {
    const fte = useRealtimeChangeOnly
      ? realtimeFte
      : isRequestor
      ? requested
      : requestSubmitted; // approver only sees submitted
    value = requestSavedAt ? getFte(fte) : undefined;
    defaultedValue = requestSavedAt
      ? getFte(allocatedMemberFte)
      : getFte(fte) || 0;
    realtimeCurrentMemberFte = getFte(
      isNil(realtimeFte) ? defaultedValue : realtimeFte
    );
    delta = roundFte(
      (!isNil(value) ? value : defaultedValue) - allocatedMemberFte
    );
    notification = newPlannerRequestorCellNotification(
      macroAllocation,
      isRequestor,
      isSkillsMandatory
    );
  }

  const [prepopulatedValue, valueSaveStatus] = getPrepopulatedValueFromForecast(
    isRequestor,
    forecastedAt,
    requestSavedAt,
    forecast,
    value
  );

  const totalCost = calculateTotalCost({
    useDeltaForBudget,
    delta,
    prepopulatedValue,
    value,
    defaultedValue,
    dailyRate,
    workingDays,
  });

  return newCell({
    lineItem,
    id: `${id}-${PLANNER_REQUESTED}`,
    columnType: PLANNER_REQUESTED,
    macroAllocationId: id,
    targetGroupId,
    sourceGroupId,
    allocationProjectId,
    isStatic: false,
    isEditable: !isMovedOut && isEditable,
    value,
    defaultedValue,
    prepopulatedValue,
    valueSaveStatus,
    delta,
    skills: note,
    isRequirementInputEnabled: !disablePlannerRequirementInput,
    notification,
    totalCost,
    dailyRate,
    workingDays,
    realtimeCurrentMemberFte,
    requestSavedAt,
  });
};
